var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('DisposeCountTitle',{attrs:{"titleName":_vm.titleName,"btnList":_vm.btnList},on:{"btnSelFn":_vm.btnSelFn}}),_c('div',{ref:"echarts1",staticClass:"main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }